// Timeframe -> allowed date range options
export const TIMEFRAMES = [
  /*{ value: "60min", label: "60 Minutes" },*/
  { value: "daily", label: "Daily" },
  { value: "weekly", label: "Weekly" },
  /*{ value: "monthly", label: "Monthly" },*/
];

export const DATE_RANGES_BY_TIMEFRAME = {
  /*"60min": [
    { value: "3M", label: "3 Months" },
    { value: "1M", label: "1 Month" },
    { value: "3W", label: "3 Weeks" },
    { value: "10D", label: "10 Days" },
    { value: "5D", label: "5 Days" },
  ],*/
  daily: [
    { value: "5D", label: "5 Days" },
    { value: "10D", label: "10 Days" },
    { value: "3W", label: "3 Week" },
    { value: "1M", label: "1 Months" },
    { value: "3M", label: "3 Months" },
    { value: "1Y", label: "1 Year" }
  ],
  weekly: [
    { value: "1M", label: "1 Months" },
    { value: "3M", label: "3 Months" },
    { value: "6M", label: "6 Months" },
    { value: "1Y", label: "1 Year" }
  ],
  monthly: [
    { value: "3M", label: "3 Months" },
    { value: "6M", label: "6 Months" },
    { value: "1Y", label: "1 Year" },
  ],
};

export const QUADRANT_COLORS = {
  leading: "#16a34a",   // green
  weakening: "#f59e0b", // orange
  lagging: "#dc2626",   // red
  improving: "#7c3aed", // purple
};

export const QUADRANT_BG = {
  leading: "#d1fae5",
  weakening: "#fed7aa",
  lagging: "#fecaca",
  improving: "#e9d5ff",
};